export const PARTNER_STATUS_APPROVED = "Approved";
export const PARTNER_STATUS_PENDING = "Pending";
export const PARTNER_STATUS_DECLINED = "Declined";
export const PARTNER_STATUS_ACCEPTED = "Accepted";
